import { Injectable } from '@angular/core';
import { Plugins } from '@capacitor/core';
import { AuthConstants } from '../config/auth-constants';
const { Storage } = Plugins;

export interface Cart{
    'id':number,
    'titulo':string,
    'precio':number,
    'precio2':number,
    'descuento':number,
    'qty':number
}

@Injectable({
  providedIn: 'root'
})


export class CartService {

  constructor() { }


  async storage(storageKey:string, value: any){
    const encryptedValue = btoa(escape(JSON.stringify(value)));
    await Storage.set({
      key:storageKey,
      value:encryptedValue
    });
  }

  async setStorage(value: any){
    const res = await Storage.get({key:AuthConstants.CART});
    console.log(value.id);
    return;

    if(res.value){
      return JSON.parse(unescape(atob(res.value)));
    } else {
      return false;
    }
  }

  async get(storageKey: string){
    const res = await Storage.get({key:storageKey});
    if(res.value){
      return JSON.parse(unescape(atob(res.value)));
    } else {
      return false;
    }
  }

  async removeItem(storageKey: string){
     Storage.remove({key:storageKey});
  }
  



}
